import {StyleSheet} from 'react-native';
import {GAME_OPERATIONS_CONTAINER_MARGIN_TOP} from 'GameOperationsManagerStyle';
import HomeScreenConstants from 'HomeScreenConstants';
import {BANNER_SIZE} from '@skillz/ui';

const MARGIN_TOP = GAME_OPERATIONS_CONTAINER_MARGIN_TOP + HomeScreenConstants.getBalanceBarHeight();

export const stylesFn = () => {
  return StyleSheet.create({
    gameOperationsSpotlightContainer: {
      height: BANNER_SIZE.height,
      flexDirection: 'row',
      width: '100%',
      marginTop: MARGIN_TOP,
    },
  });
};
